// extracted by mini-css-extract-plugin
module.exports = {"select_box":"EditSchoolYear_select_box_uVQA6","select_box_wrap":"EditSchoolYear_select_box_wrap_23zAx"};